<script>
	import { user, step, TokenValid, TokenLoading, Errors } from '../store.js';
	import { TokenSubmit } from '../service.js';
	import LoadingButton from '../components/LoadingButton.svelte';

	const forward = async () => {
		await TokenSubmit()
		if ($TokenValid) {
			unsubscribe()
			step.set(2)
		}
	}

	const unsubscribe = user.subscribe( user => {
		if (user.token) {
			user.token = user.token.toUpperCase()
				.replace(/[^A-Z]/g, "")

			if (user.token.length === 5) {
				forward()
			}
		}
	})


</script>

<div class="content">
	<h2>Start your free MODsense trial now</h2>
	<p>We provide free access to our web-based data management dashboard, without submission of payment details. Enter your code to get started.</p>

	<div class="input-group">
		<input class={ $user.token != '' ? 'has-value' : ''} 
					bind:value={$user.token} 
					placeholder="Code" 
					type="text"
					maxlength="5"
		>
	</div>

	{#if !!$Errors.token }
		<span class="error">{$Errors.token}</span>
	{/if}

	<LoadingButton clickEvent="{() => forward()}" loading="{$TokenLoading}" >
		Next
	</LoadingButton>
</div>

<style lang="scss">
@import '../scss/variables.scss';
	p {
		margin-bottom: 30px;
	}

	input {
		color: black;
		background-color:$lighter-grey;
		border: 2px solid $light-grey;
		height: 50px;
		width: 100%;
		line-height: 50px;
		padding: 5px 10px;
		margin-bottom: 0;
		text-transform: uppercase;
		&.has-value {
			background-color: white;
		}
	}

	input::placeholder {
		font-weight: 600;
		color: $medium-grey
	}
</style>